import { useTranslation } from 'react-i18next';
import React from 'react';
import PosterFeature from './PosterFeature';
import { asset, PageHeading } from './UI';
export default function Expo() {
  const {
    t
  } = useTranslation();
  const groups = [['01', 'Malaysia', 'Selangor International Summit Expo 2019', ['selangor1.jpeg', 'selangor2.jpeg']], ['02', t("singapore"), 'Singapore Expo 2019', ['singapore1.jpg', 'singapore2.jpeg', 'singapore3.jpeg', 'singapore4.jpeg']], ['03', 'Indonesia', t("connecting_at_exhibitions_across_indonesia"), Array.from({
    length: 8
  }, (_, i) => `domestik${i + 1}.jpeg`)]];
  return <main id="main" className="wrap page-content"><PageHeading eyebrow={t("from_solok_to_new_horizons")} title={t("sharing_flavours_connecting_stories")}>{t("follow_nak_tarasos_journey_as_we_introduce_innovative_rendang")}</PageHeading><PosterFeature variant="event" />{groups.map(([n, location, title, photos]) => <section className="expo-section" key={n}><div className="expo-heading"><span className="eyebrow">{n} / {location}</span><h2>{title}</h2></div><div className={`gallery-grid ${photos.length === 2 ? 'two' : ''}`}>{photos.map((photo, i) => <figure key={photo}><img loading="lazy" src={asset(photo)} alt={t("photo", {
            value: title,
            value2: i + 1
          })} /></figure>)}</div></section>)}</main>;
}
